import { render, staticRenderFns } from "./StartupsModal.vue?vue&type=template&id=7c0c5ea8&scoped=true&"
import script from "./StartupsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StartupsModal.vue?vue&type=style&index=0&id=7c0c5ea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0c5ea8",
  null
  
)

export default component.exports